"use strict";
(self["webpackChunkdev"] = self["webpackChunkdev"] || []).push([[4074],{

/***/ 4074:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ parallax)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
// components/parallax.js


/**
 * * Initializes elements with a scroll parallax effect.
 * 
 * @param wrapper: element with [data-component="parallax"] attribute. Element to be transformed on scroll.
 * 
 * @options
    * [data-parallax] {required} -  passes the transform css attribute (translate-y, translate-x etc)
    * [data-container] {required} - container element to 
    * [data-from] - initial CSS property value
 */

function parallax({ wrapper }) {
  let $node = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper);

  const cache = {
    $container: jquery__WEBPACK_IMPORTED_MODULE_0___default()($node.data('container'))
  }

  const settings = {
    transformProperty: $node.data('parallax'),
    transformUnit: ($node.data('parallax-unit') || 'px'),
    from: $node.data('from'),
    to: $node.data('to'),
  }

  const init = function () {
    // initObserver();
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('scroll', observeIntersect);
  }

  function observeIntersect() {
    let topOffset = cache.$container[0].getBoundingClientRect().top;

    let ratio = topOffset / window.screen.availHeight;
    let transformAmount = settings.from * ratio;

    $node.css({ transform: `${settings.transformProperty}(${transformAmount + settings.transformUnit})` })
  }

  init()
}

/***/ })

}]);